import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { MenuService, AuthenticationService } from '../services';
import 'rxjs';

@Injectable()
export class MenuResolver implements Resolve<any> {
  constructor(
    private menuService: MenuService,
    private authenticationService: AuthenticationService
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    // get user info to be shown in navbar if logged in
    let userInfo = this.authenticationService.getUserInfo();

    let data = {
      type: 'user',
      role_id: userInfo.current_role.role_id
    };
    return this.menuService
      .getMenu(data)
      .then(res => {
        return res.data;
      });
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/resolvers/menu.resolver.ts